
import { Bubble, BubbleType } from '../../bubbles/types';
import { BubbleView } from './BubbleView';
import { IEvent } from 'js/bubbleCore/events';
import { TweenManager } from 'framework/TweenManager/TweenManager';

export class BubbleViewHandler<T extends BubbleType> {
  public readonly view: BubbleView;
  public readonly model: Bubble<T>;

  constructor(bubbleView: BubbleView, model: Bubble<T>) {
    this.view = bubbleView;
    this.model = model;
  }

  public initView(): void {
    //
  }

  public updateViewOnChange(): void {
    //
  }

  public animatePopOut(): void {

  }

  public animateKill(event: IEvent): void {
    //
  }

  public cleanup(): void {
    //
  }
}